
import PublicLayout from './PublicLayout'

export default PublicLayout



// WEBPACK FOOTER //
// ./src/layouts/PublicLayout/index.js